import { Chip } from "@gpstrackit/react-controls";
import cx from "classnames";
import "./chipbadge.scss";

const ChipBadge = (props) => {
    const { status, width, label } = props;
    return (
        <div className={cx("chip-status", (status === "Active" || status === "Activo" || status === "active") || status !== "Active"  && "chip-container")} style={{ width: width || '100px', textAlign: 'center' }}>
            <Chip label={label} />
        </div>
    )
}

export default ChipBadge